export default function(){
    Set.prototype.toJSON = function() {return [...this]}
}